/** Folder trees, tech stack rows, and config keys per ZiniHub app. */
export const FOLDER_STRUCTURE = {
  admin: {
    root: "ZiniHub/",
    tree: [
      { type: "dir", name: "frontend/src/", children: [
        { type: "dir", name: "pages/Hub/", children: [
          { type: "file", name: "Stores.js", note: "My Hub biz grid — /hub" },
          { type: "file", name: "ItemForm.js", note: "Product/service editor" },
          { type: "file", name: "createStore.js", note: "New biz flow — /biz/new" },
        ] },
        { type: "dir", name: "pages/", children: [
          { type: "file", name: "UserHome.js", note: "App shell + nav" },
          { type: "file", name: "OrderMonitoring.js", note: "/dashboard" },
          { type: "file", name: "MediaGallery.js", note: "/gallery — hub/biz/items segments" },
          { type: "file", name: "PocketDiary.js", note: "/notebook" },
          { type: "file", name: "HubSettings.js", note: "/hub-settings + KYC entry" },
        ] },
        { type: "dir", name: "services/", children: [
          { type: "file", name: "mediaOperationTypes.js", note: "S3 manifest ops — must match Lambda" },
        ] },
        { type: "file", name: "App.js", note: "CRA routes — admin domain" },
      ] },
      { type: "dir", name: "BE Only/ziniz_BE/", children: [
        { type: "file", name: "template.yaml", note: "SAM — API + Lambdas + DynamoDB" },
      ] },
    ],
  },
  customer: {
    root: "MyHub_CustApp/",
    tree: [
      { type: "dir", name: "frontend/src/", children: [
        { type: "dir", name: "pages/", children: [
          { type: "file", name: "DiscoverPage.js", note: "visitmyhub.online/discover" },
          { type: "file", name: "HubStorefront.js", note: "hub subdomain /hub" },
          { type: "file", name: "BizStorefront.js", note: "/:bizSlug" },
          { type: "file", name: "CheckoutPage.js", note: "/checkout" },
          { type: "file", name: "OrderMonitoringCust.js", note: "/orders" },
          { type: "file", name: "ProfilePage.js", note: "/profile + addresses" },
        ] },
        { type: "file", name: "App.js", note: "CustShell routes — visitmyhub + hub22 subdomain" },
      ] },
    ],
  },
};

export const TECH_STACK = {
  admin: [
    { layer: "Frontend", tech: "React 18 (CRA)", note: "test-zinihub.ziniz.online — AppShell + PublicShell" },
    { layer: "UI", tech: "Ant Design 5", note: "Forms, tables, modals" },
    { layer: "API", tech: "REST via API Gateway", note: "OrganizeAnything_BE Lambdas" },
    { layer: "Data", tech: "DynamoDB", note: "Hub · Biz · Items · Orders" },
    { layer: "Media", tech: "S3 + CloudFront", note: "media.ziniz.online — manifest.json per segment" },
    { layer: "Auth", tech: "Cognito / session", note: "Unified login component with customer app" },
  ],
  customer: [
    { layer: "Frontend", tech: "React 18 (CRA)", note: "visitmyhub.online + hub22.visitmyhub.online" },
    { layer: "UI", tech: "Ant Design 5", note: "CustShell sidebar + cart drawer" },
    { layer: "API", tech: "Same REST surface", note: "Public storefront + protected checkout/orders" },
    { layer: "Cart", tech: "Client state + login gate", note: "Preserve cart across auth handoff" },
    { layer: "Media", tech: "CDN manifest", note: "Biz banners + product images from hub media paths" },
  ],
};

export const CONFIGS = {
  admin: [
    { key: "REACT_APP_API_BASE", where: "frontend/.env", note: "API Gateway stage URL" },
    { key: "REACT_APP_MEDIA_CDN", where: "frontend/.env", note: "https://media.ziniz.online" },
    { key: "REACT_APP_CUST_ORIGIN", where: "frontend/.env", note: "visitmyhub.online — preview links" },
    { key: "hub media path", where: "S3", note: "MyHub/{env}/hubs/media/{hubId}/hub|biz/{bizId}/..." },
    { key: "subscription plans", where: "BE config", note: "Trial · Starter · Professional · Enterprise limits" },
  ],
  customer: [
    { key: "REACT_APP_API_BASE", where: "frontend/.env", note: "Shared backend with admin" },
    { key: "REACT_APP_HUB_SUBDOMAIN", where: "runtime", note: "hub22.visitmyhub.online — hub context from host" },
    { key: "REACT_APP_DISCOVER_API", where: "frontend/.env", note: "Search service — 503 error state on failure" },
    { key: "cart persistence", where: "sessionStorage", note: "Survive login redirect to checkout" },
  ],
};
